import { render, staticRenderFns } from "./ModalWrapper.vue?vue&type=template&id=0ec9a581&scoped=true&"
import script from "./ModalWrapper.vue?vue&type=script&lang=js&"
export * from "./ModalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ModalWrapper.vue?vue&type=style&index=0&id=0ec9a581&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec9a581",
  null
  
)

export default component.exports